import { IPurchaseItemDataDto } from '@pressreader/commerce-api/legacy';

import { IEcommerceItem } from '../models/models';

function mapPurchaseItemDataDto(dto: IPurchaseItemDataDto): IEcommerceItem {
    return {
        id: dto.id,
        name: dto.name,
        brand: dto.brand,
        category: dto.category,
        variant: dto.variant,
        subTotal: dto.subTotal,
        discount: dto.discount,
        total: dto.total,
        quantity: dto.quantity,
        coupon: dto.coupon,
    };
}

export { mapPurchaseItemDataDto };
